import { OverlayPopupMenu } from 'features/overview'
import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'features/siteMap/contexts/FeatureInteractionContext'
import { EditFeatureMenuContent } from 'features/siteMap/popupMenus/editMode/editFeature/EditFeatureMenuContent'
import React, { FC, useMemo } from 'react'
import { GeckoSiteModel, GeckoUnit, isSiteFeaturePrimitive } from 'types'

interface EditFeatureMenuProps {
  getDraggableGroup: () => React.RefObject<HTMLDivElement | null>[]
  assignRef: React.RefObject<HTMLDivElement>
  siteModel: GeckoSiteModel
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}

export const EditFeatureMenu: FC<EditFeatureMenuProps> = (props) => {
  const {
    showFeaturePopupMenu,
    setShowFeaturePopupMenu,
    selectedFeature,
    setSelectedFeature,
  } = useFeatureInteractionContext()

  const selectedSiteModelFeaturePrimitive = useMemo(() => {
    if (!selectedFeature) return undefined
    const siteModelFeature = Object.values(props.siteModel.data.features).find(
      (curFeature) => {
        if (selectedFeature.type === MapFeatureType.Unit) {
          return curFeature.unit_id === selectedFeature.unitID
        }
        return curFeature.id === selectedFeature.featureID
      }
    )
    if (!siteModelFeature) {
      throw new Error(
        `Invalid feature was selected - feature with 
        ${selectedFeature.type === MapFeatureType.Unit ? `unitID ${selectedFeature.unitID}` : `featureID ${selectedFeature.featureID}`}
        not found in site model.`
      )
    }
    return isSiteFeaturePrimitive(siteModelFeature)
      ? siteModelFeature
      : undefined
  }, [props.siteModel, selectedFeature])

  return (
    <>
      {showFeaturePopupMenu && (
        <OverlayPopupMenu
          getDraggableGroup={props.getDraggableGroup}
          assignRef={props.assignRef}
          title={!selectedFeature ? 'Add New Feature' : 'Edit Feature'}
          closeFunction={() => {
            setShowFeaturePopupMenu(undefined)
            // TODO: If / when selection state is used for more than this menu,
            // closing the menu should not deselect the feature.
            setSelectedFeature(undefined)
          }}
          startPosition={showFeaturePopupMenu}>
          <EditFeatureMenuContent
            selectedFeature={selectedFeature}
            selectedFeaturePrimitive={selectedSiteModelFeaturePrimitive}
            allUnitsAtSite={props.allUnitsAtSite}
          />
        </OverlayPopupMenu>
      )}
    </>
  )
}
